<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <g fill="none" fill-rule="evenodd">
      <g :fill="color">
        <g>
          <g>
            <path d="M6.857 0v5.142H12v1.715H6.857V12H5.143l-.001-5.143H0V5.143l5.142-.001V0h1.715z" transform="translate(-1037 -664) translate(128 619) translate(900 36) translate(9 9)" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#164194'
    }
  }
}
</script>